'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of patient account mobile
 */ const PatientAccountMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M104 52C104 80.7188 80.7188 104 52 104C23.2812 104 0 80.7188 0 52C0 23.2812 23.2812 0 52 0C80.7188 0 104 23.2812 104 52Z",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.0234",
                y: "68.7812",
                width: "17.5976",
                height: "5.18509",
                rx: "1.61817",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.516 19H63.012C64.6463 19.009 66.2108 19.658 67.3648 20.8059C68.5188 21.9537 69.1689 23.5072 69.1734 25.1282V78.5885C69.1688 80.2125 68.5164 81.7686 67.3587 82.9169C66.201 84.0652 64.6321 84.7123 62.9948 84.7168H40.4989C38.8616 84.7123 37.2927 84.0652 36.135 82.9169C34.9772 81.7686 34.3248 80.2125 34.3203 78.5885V66.83V59.2622V57.4036V25.1282C34.3249 23.5014 34.9796 21.9427 36.1411 20.7939C37.3025 19.6451 38.8758 19 40.516 19Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.3838 68.8691H45.1428C43.7328 68.8691 42.5898 70.0028 42.5898 71.4013C42.5898 72.7998 43.7328 73.9334 45.1428 73.9334H58.3838C59.7937 73.9334 60.9367 72.7998 60.9367 71.4013C60.9367 70.0028 59.7937 68.8691 58.3838 68.8691Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "48.8438",
                y: "73.9102",
                width: "6.04773",
                height: "5.86592",
                rx: "2.93296",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.0156",
                y: "21.916",
                width: "29.7011",
                height: "48.5272",
                rx: "1.98447",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52.026",
                cy: "46.7545",
                r: "10.9869",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("mask", {
                id: "mask0_3427_24183",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: "41",
                y: "35",
                width: "23",
                height: "23",
                children: /*#__PURE__*/ jsxRuntime.jsx("circle", {
                    cx: "52.026",
                    cy: "46.7545",
                    r: "10.9869",
                    fill: "#D9D9D9"
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                mask: "url(#mask0_3427_24183)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M52.0111 48.3609C54.576 48.3609 56.6695 46.2764 56.6695 43.696C56.6695 41.1156 54.576 39.043 52.0111 39.043C49.4462 39.043 47.3516 41.1275 47.3516 43.696C47.3516 46.2645 49.445 48.3609 52.0111 48.3609Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M43.9521 52.7166C43.7535 53.2899 43.5813 53.8644 43.4453 54.4498C45.5591 56.795 48.6131 58.2804 51.9896 58.2804C55.3662 58.2804 58.4632 57.1582 60.5783 54.8129C60.4422 54.2275 60.2245 53.2911 60.0259 52.7166C59.3205 50.7199 57.8255 49.1848 55.9825 48.3613C54.8449 49.1593 53.4606 49.622 51.9884 49.622C50.5162 49.622 49.1319 49.1605 47.9943 48.3735C46.1393 49.1848 44.6551 50.7321 43.9509 52.7166H43.9521Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            })
        ]
    });
};

exports.PatientAccountMobile = PatientAccountMobile;
//# sourceMappingURL=PatientAccountMobile.cjs.map
